module.exports = __webpack_public_path__ + "img/refer-3.25774412.svg";